import { gql } from '@apollo/client';
import MASTERCODE_FRAGMENT from 'graph/fragments/mastercodes';

const SCHEDULE_UNLOCK_MASTERCODE = gql`
  mutation scheduleUnlockMastercode($mastercodeId: Int!, $date: DateTime!) {
    scheduleUnlockMastercode(where: { id: $mastercodeId }, date: $date) {
      ...MastercodeFragment
    }
  }
  ${MASTERCODE_FRAGMENT}
`;

export default SCHEDULE_UNLOCK_MASTERCODE;
